import React, { useMemo } from 'react';
import PatientDetailsCard from 'components/PatientDetailsCard';
import AppleHealthIcon from 'components/Common/AppleHealthIcon';
import AppleHealthTooltip from 'components/Common/AppleHealthTooltip';
import { WaypointSource } from 'pages/Dashboard/types/waypoints.types';
import { Box } from '@mui/material';

interface AppleHealthChartsWrapperProps {
  title: string;
  renderChart: React.ReactElement;
  isLoading?: boolean;
  noData?: boolean;
  infoIcon?: boolean;
  infoIconText?: React.ReactElement;
  avgScore?: string;
  showViewDetails?: boolean;
  isAppleHealthWaypoint?: boolean;
  sourceObject?: Partial<WaypointSource>;
  timeFrame?: string;
  numberOfLogs?: number;
  onViewDetails?: () => void;
  onTimeFrameChange?: (v: string) => void;
  gridSize?: number;
}

function AppleHealthChartsWrapper({
  title,
  renderChart,
  isLoading,
  noData,
  infoIcon,
  infoIconText,
  avgScore,
  showViewDetails,
  isAppleHealthWaypoint = true,
  sourceObject,
  timeFrame,
  numberOfLogs,
  onViewDetails,
  onTimeFrameChange,
  gridSize = 6,
}: AppleHealthChartsWrapperProps) {
  const action = useMemo(() => {
    if (isAppleHealthWaypoint && !showViewDetails) {
      return <AppleHealthIcon sourceObject={sourceObject} />;
    }

    return null;
  }, [isAppleHealthWaypoint, showViewDetails, sourceObject]);

  return (
    <PatientDetailsCard
      title={title}
      showViewDetails={showViewDetails}
      gridProps={{ xs: 12, md: gridSize }}
      onTimeFrameChange={onTimeFrameChange}
      infoIconTooltip={<AppleHealthTooltip text={infoIconText as React.ReactElement} iconType='info_outlined' />}
      showInfoIcon={!!infoIcon}
      avgChipLabel={avgScore ? `Avg. Score ${avgScore}` : ''}
      numberOfLogs={numberOfLogs}
      onViewDetails={onViewDetails}
      renderAction={action}
      selectTimeFrame={timeFrame}
      isLoading={isLoading}
      noData={noData}
      noDataType={isAppleHealthWaypoint ? 'device' : 'default'}
    >
      <Box height='100%' width='100%' display='flex' flexDirection='column' justifyContent='flex-end'>
        {renderChart}
      </Box>
    </PatientDetailsCard>
  );
}

export default AppleHealthChartsWrapper;
